import * as React from 'react'

import { RetailerBlock } from "@components"


export default function retailerColumn() {
    return {
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, date, siteURL }) => {
			return <>
				<RetailerBlock
					retailer={value}
					country={country}
					date={date}
					siteURL={siteURL}
				/>
			</>
			}
        }
    }
}